export default __webpack_public_path__ + "static/media/troutags_thumb.a24b030f.jpg";